export default __webpack_public_path__ + "static/media/card4.aab3cf32.png";